import React from "react";
import "./style.scss";

const Loader: React.FC = () => {
  return <div className="three-sticks-loader"><div></div><div></div><div></div></div>;
};

export default Loader;
